var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const isLangPublished = (data, lang) => {
    if (!data)
        return false;
    const { publishedLanguages } = data.allProductInfo || data.allProductInfoById;
    return publishedLanguages === null || publishedLanguages === void 0 ? void 0 : publishedLanguages.includes(lang);
};
export const fetchWithCacheClientSide = (identifier, options) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { request, preview, locale } = options;
    // try to get data in locale but also default to check if product is even published in requested locale
    const response = yield axios.post(`${process.env.NEXT_PUBLIC_DEPLOY_URL}/api/cache-get-multiple`, {
        cacheKeys: [`${identifier}/${locale}`, identifier],
    });
    const value = response.data[0];
    const defaultValue = response.data[1];
    const valueWithBackup = value || defaultValue;
    const productInfo = (valueWithBackup === null || valueWithBackup === void 0 ? void 0 : valueWithBackup.allProductInfo) || (valueWithBackup === null || valueWithBackup === void 0 ? void 0 : valueWithBackup.allProductInfoById);
    if (productInfo === null || productInfo === void 0 ? void 0 : productInfo.offboardingRedirect)
        return value || defaultValue;
    const dev = process.env.NODE_ENV === 'development';
    const publishedInRequestLang = isLangPublished(defaultValue, locale);
    const overrideCache = preview || dev;
    // CASE: product is not published in requested lang but default lang is in cache
    if (!publishedInRequestLang && defaultValue && !overrideCache) {
        return defaultValue;
    }
    // CASE: product is in cache
    if (value && !overrideCache) {
        return value;
    }
    // CASE: product is not in cache under requested lang
    try {
        const data = yield request();
        if (
        // @ts-expect-error Make sure the offboarding redirect get's handled in [productPage].tsx
        (_a = ((data === null || data === void 0 ? void 0 : data.allProductInfo) || (data === null || data === void 0 ? void 0 : data.allProductInfoById))) === null || _a === void 0 ? void 0 : _a.offboardingRedirect) {
            // @ts-expect-error
            return data;
        }
        if (!preview) {
            yield axios.post(`${process.env.NEXT_PUBLIC_DEPLOY_URL}/api/store-in-cache`, {
                cacheKey: identifier,
                data,
            });
        }
        return data;
    }
    catch (res) {
        const response = res === null || res === void 0 ? void 0 : res.response;
        const graphQLError = (_b = response === null || response === void 0 ? void 0 : response.errors) === null || _b === void 0 ? void 0 : _b.length;
        const networkError = response === null || response === void 0 ? void 0 : response.error;
        console.error(res.response);
        if (graphQLError) {
            const message = response.errors[0].message;
            throw new Error(message);
        }
        if (networkError) {
            throw new Error(response.error);
        }
        throw new Error('error');
    }
});
